/* Beträge in Euro: Anzeige und Eingabe (bisher in modules/finanzen/logik.ts, unverändert). Im Kern, weil Budget und die Summen eines
   Förderantrags dieselbe Eingabe und Prüfung nutzen (BAUPLAN-VORHABEN-ARTEN.md, Abschnitt 5). Gerechnet wird in Cent. */

const EUR = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });

/** 123456 → „1.234,56 €“ */
export const euro = (cent: number) => EUR.format(cent / 100);
/** Für Eingabefelder und CSV: „1.234,56“, ohne Tausenderpunkt „1234,56“ */
export const betragText = (cent: number, gruppiert = true) =>
  (cent / 100).toLocaleString("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: gruppiert });

export type Gelesen = { ok: true; wert: number | null } | { ok: false; fehler: string };

/** Liest „1.234,56“, „12,5“, „12.5“, „12 €“. Leer heißt null. Negative Zahlen gibt es nicht. */
export function zahlLesen(text: string): number | null | undefined {
  let t = text.replace(/[€\s]/g, "");
  if (t === "") return null;
  if (/^\d{1,3}(\.\d{3})+(,\d+)?$/.test(t)) t = t.replace(/\./g, "");
  if (!/^\d+([.,]\d+)?$/.test(t)) return undefined;
  const n = Number(t.replace(",", "."));
  return Number.isFinite(n) ? n : undefined;
}

/** Höchster Betrag, der in die Datenbank passt (integer in Cent) */
export const HOECHSTBETRAG_CENT = 2_000_000_000;

/** Euro mit Komma in Cent. leer: erlaubt (Ist offen) oder Fehler. */
export function centLesen(text: string, leerErlaubt: boolean): Gelesen {
  const n = zahlLesen(text);
  if (n === null) return leerErlaubt ? { ok: true, wert: null } : { ok: false, fehler: "Bitte einen Betrag eingeben, zum Beispiel 12,50." };
  if (n === undefined) return { ok: false, fehler: "Bitte einen Betrag wie 12,50 eingeben." };
  const cent = Math.round(n * 100);
  if (cent > HOECHSTBETRAG_CENT) return { ok: false, fehler: "Der Betrag ist zu groß." };
  return { ok: true, wert: cent };
}
